import { productPanelApi } from '../../api';

import { ProductPanelFilter } from '../../types/productpanel/ProductPanelFilter';

const ProductPanelService = {
    /**
     * Obtiene productos filtrados.
     * POST /api/product-panel/filtered
     */
    getFilteredProducts: async (
        filters: ProductPanelFilter,
        page = 0,
        size = 10
    ) => {
        const response = await productPanelApi.addCustom(
            `/filtered?page=${page}&size=${size}`,
            filters
        );

        return response.data;
    },

    /**
     * Obtiene las categorías disponibles para la sucursal.
     * GET /api/product-panel/categories?branchId=1
     */
    getAvailableCategories: async (
        branchId: number
    ) => {
        const response =
            await productPanelApi.fetchCustom(
                `/categories?branchId=${branchId}`
            );

        return response.data;
    },

    /**
     * Obtiene las subcategorías disponibles
     * para una categoría específica.
     *
     * GET /api/product-panel/sub-categories
     */
    getAvailableSubCategories: async (
        branchId: number,
        categoryId: number
    ) => {
        const response =
            await productPanelApi.fetchCustom(
                `/sub-categories?branchId=${branchId}&categoryId=${categoryId}`
            );

        return response.data;
    },

    /**
     * Obtiene las marcas disponibles
     * para la sucursal.
     *
     * GET /api/product-panel/brands
     */
    getAvailableBrands: async (
        branchId: number
    ) => {
        const response =
            await productPanelApi.fetchCustom(
                `/brands?branchId=${branchId}`
            );

        return response.data;
    },

    /**
     * Recupera la imagen del producto.
     * GET /api/product-panel/image/{filename}
     */
    getProductImage: async (
        filename: string
    ): Promise<string | null> => {
        try {
            const response =
                await productPanelApi.fetchBlob(
                    `/image/${filename}`
                );

            return URL.createObjectURL(
                response.data
            );
        } catch (error) {
            console.error(
                '❌ Error obteniendo imagen del producto:',
                error
            );

            return null;
        }
    },
};

export default ProductPanelService;